import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SearchListComponent } from "./search-list.component";
import { LoadingIndicatorModule } from "../loading-indicator/loading-indicator.module";
import { SearchModule } from "../search/search.module";

@NgModule({
	imports: [CommonModule, SearchModule, LoadingIndicatorModule],
	declarations: [SearchListComponent],
	exports: [SearchListComponent],
})
export class SearchListModule {}
